
import { Result } from 'core/infrastructure';
import { DataGrid } from 'core/ui/controls/DataGrid';
import { DataGridColumn } from 'core/ui/controls/DataGrid.Column';
import { ColumnFilter } from 'core/ui/controls/DataGrid.Filter';
import { configureFilter } from './LegacyDataGrid.FilterDialog';

export class LegacyDataGrid<T> extends DataGrid<T> {

	protected override async configureFilter(currentFilters: ColumnFilter<T>[], columns: DataGridColumn<T>[], items: T[]): Promise<Result<ColumnFilter<T>[], unknown>> {
		return configureFilter(currentFilters, columns, items);
	}
}